import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Footer, Landing, About, Skills, Testimonials, Blog, Education, Experience, Contacts, Projects, Services, Achievement, Loading } from '../../components'
import { headerData } from '../../data/headerData'
import { DataContext } from '../../contexts/DataContext';



function Main() {
    const { isLoading } = useContext(DataContext);
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Porfolio</title>
            </Helmet>
            <div>
                {isLoading ? (
                    <Loading />
                ) : (
                    <div>
                        {/* Your main content */}
                        <Navbar />
                        <Landing />
                        <About />
                        <Education />
                        <Skills />
                        <Experience />
                        {/* <Projects /> */}
                        {/* <Achievement /> */}
                        <Services />
                        {/* <Testimonials /> */}
                        {/* <Blog /> */}
                        <Contacts />
                        {/* <Footer /> */}
                    </div>
                )}
            </div>

        </div>
    )
}

export default Main
